import React, { useState } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { WealthManagersTab } from "./tabs/WealthManagersTab"
import { ParaplannersTab } from "./tabs/ParaplannersTab"
import { ClientsTab } from "./tabs/ClientsTab"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

type Organization = { id: number; name: string; slug: string }
type TabKey = "wealth_managers" | "paraplanners" | "clients"

const TABS: { key: TabKey; label: string }[] = [
  { key: "wealth_managers", label: "Wealth Managers" },
  { key: "paraplanners", label: "Paraplanners" },
  { key: "clients", label: "Clients" },
]

export const FspAdminDashboard = ({ organization }: { organization: Organization }) => {
  const [activeTab, setActiveTab] = useState<TabKey>("wealth_managers")

  return (
    <QueryClientProvider client={queryClient}>
      <div className="fsp-admin wb-clients-redesign">
        <div className="fsp-admin__title">
          <span className="fsp-admin__eyebrow">FSP Admin</span>
          <h1>{organization.name}</h1>
        </div>
        <nav className="fsp-admin__tabs">
          {TABS.map(({ key, label }) => (
            <button
              key={key}
              className={`fsp-admin__tab ${activeTab === key ? "fsp-admin__tab--active" : ""}`}
              onClick={() => setActiveTab(key)}
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="fsp-admin__panel">
          {activeTab === "wealth_managers" && <WealthManagersTab />}
          {activeTab === "paraplanners" && <ParaplannersTab />}
          {activeTab === "clients" && <ClientsTab organizationId={organization.id} />}
        </div>
      </div>
    </QueryClientProvider>
  )
}
